/**
 * Calculates the position of the menu based on the expand direction, menu rectangle, and trigger rectangle.
 *
 * @param {string} expandDirection - desired expand direction ('top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight').
 * @param {DOMRect} menuRect - rectangle representing the menu element.
 * @param {DOMRect} triggerRect - rectangle representing the trigger element.
 * @returns {string} - calculated expanded direction of the menu ('top', 'bottom', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight').
 */

const calculateMenuPosition = (expandDirection, menuRect, triggerRect) => {
  // calculate available space around the trigger element
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  const hasSpaceTop = triggerRect.top >= menuRect.height;
  const hasSpaceBottom = viewportHeight - triggerRect.bottom >= menuRect.height;
  const hasSpaceLeft = triggerRect.left >= menuRect.width;
  const hasSpaceRight = viewportWidth - triggerRect.right >= menuRect.width;

  switch (expandDirection) {
    case 'top':
      if (hasSpaceTop && hasSpaceLeft && hasSpaceRight) return 'top';

      if (hasSpaceTop && hasSpaceLeft) return 'topLeft';
      if (hasSpaceTop && hasSpaceRight) return 'topRight';

      if (hasSpaceBottom && hasSpaceLeft && hasSpaceRight) return 'bottom';

      if (hasSpaceBottom && hasSpaceLeft) return 'bottomLeft';
      if (hasSpaceBottom && hasSpaceRight) return 'bottomRight';

      return 'bottom'; // default to 'bottom'

    case 'bottom':
      if (hasSpaceBottom && hasSpaceLeft && hasSpaceRight) return 'bottom';

      if (hasSpaceBottom && hasSpaceLeft) return 'bottomLeft';
      if (hasSpaceBottom && hasSpaceRight) return 'bottomRight';

      if (hasSpaceTop && hasSpaceLeft && hasSpaceRight) return 'top';

      if (hasSpaceTop && hasSpaceLeft) return 'topLeft';
      if (hasSpaceTop && hasSpaceRight) return 'topRight';

      return 'bottom';

    case 'topLeft':
      if (hasSpaceTop && hasSpaceLeft) return 'topLeft';
      if (hasSpaceBottom && hasSpaceLeft) return 'bottomLeft';
      if (hasSpaceTop && hasSpaceRight) return 'topRight';
      if (hasSpaceBottom && hasSpaceRight) return 'bottomRight';

      return 'top'; // default to 'top'

    case 'topRight':
      if (hasSpaceTop && hasSpaceRight) return 'topRight';
      if (hasSpaceBottom && hasSpaceRight) return 'bottomRight';
      if (hasSpaceTop && hasSpaceLeft) return 'topLeft';
      if (hasSpaceBottom && hasSpaceLeft) return 'bottomLeft';

      return 'top';

    case 'bottomLeft':
      if (hasSpaceBottom && hasSpaceLeft) return 'bottomLeft';
      if (hasSpaceTop && hasSpaceLeft) return 'topLeft';
      if (hasSpaceBottom && hasSpaceRight) return 'bottomRight';
      if (hasSpaceTop && hasSpaceRight) return 'topRight';

      return 'bottom';

    case 'bottomRight':
      if (hasSpaceBottom && hasSpaceRight) return 'bottomRight';
      if (hasSpaceTop && hasSpaceRight) return 'topRight';
      if (hasSpaceBottom && hasSpaceLeft) return 'bottomLeft';
      if (hasSpaceTop && hasSpaceLeft) return 'topLeft';

      return 'bottom';

    default:
      return 'bottom';
  }
};

// eslint-disable-next-line import/prefer-default-export
export { calculateMenuPosition };
